import React from 'react'
import { SliderButton } from '.'
import { css, cx } from '@emotion/css'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { PureQueryOptions } from 'apollo-client'
import { updateRoute } from '../route'
import { Tutorial } from '../../graphql/schema/queries/tutorials'

interface RenderPanelProps {
  readonly onClose: () => void
  readonly onFooterClick: () => void
  readonly className: string
}

export interface CustomSlidingTutorialProps {
  readonly isOpen: boolean
  readonly isVisible: boolean
  readonly tutorialKey: Tutorial
  readonly orgUuid: string
  readonly appId?: string
  readonly yOffset?: number
  readonly zIndex: number
}

interface SlidingTutorialProps {
  readonly tutorialKey: string
  readonly orgUuid: string
  readonly isOpen: boolean
  readonly renderPanel: (
    renderPanelProps: RenderPanelProps
  ) => React.ReactElement<any>
  readonly refetchQueries?: PureQueryOptions[]
  readonly yOffset?: number
  readonly route?: string
  readonly zIndex: number
}

interface State {
  readonly isOpen: boolean
}

const markAsViewedSlidingTutorial = gql`
  mutation markAsViewedSlidingTutorial($orgUuid: ID!, $tutorialKey: String!) {
    markAsViewedSlidingTutorial(
      input: { orgUuid: $orgUuid, tutorialKey: $tutorialKey }
    ) {
      _placeholder
    }
  }
`

class MarkAsViewedMutation extends Mutation<
  any,
  {
    readonly orgUuid: string
    readonly tutorialKey: string
  }
> {}

const panelRightPosition: number = -450
const panelSlideInCss = css`
  transform: translateX(0);
`
const panelSlideOutCss = css`
  transform: translateX(${panelRightPosition}px);
`

const getSliderButtonCss = (zIndex: number) => {
  return css`
    z-index: ${zIndex};
  `
}

const getPanelCss = (yOffset: number, isOpen: boolean, zIndex: number) => {
  const panelCss = css`
    z-index: ${zIndex};
    position: fixed;
    top: ${yOffset}px;
    right: ${panelRightPosition}px;
    height: -webkit-calc(100% - ${yOffset}px);
    height: -moz-calc(100% - ${yOffset}px);
    height: calc(100% - ${yOffset}px);
    transition: transform 400ms ease-in;
  `
  return isOpen ? cx(panelCss, panelSlideOutCss) : cx(panelCss, panelSlideInCss)
}

export class SlidingTutorialContent extends React.Component<
  SlidingTutorialProps,
  State
> {
  public state = {
    isOpen: this.props.isOpen
  }

  public render() {
    const { isOpen } = this.state
    const {
      orgUuid,
      tutorialKey,
      refetchQueries,
      yOffset = 80,
      route,
      zIndex
    } = this.props

    return (
      <div>
        <MarkAsViewedMutation mutation={markAsViewedSlidingTutorial}>
          {(markAsViewedSlidingTutorial) => {
            return this.props.renderPanel({
              className: getPanelCss(yOffset, isOpen, zIndex),
              onClose: () => {
                this.toggle(false)
              },
              onFooterClick: () => {
                this.toggle(false)
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                markAsViewedSlidingTutorial({
                  refetchQueries,
                  variables: { orgUuid, tutorialKey },
                  optimisticResponse: {
                    markAsViewedSlidingTutorial: {
                      _placeholder: true,
                      __typename: 'SlidingTutorialMarkResponseType'
                    },
                    __typename: 'Mutation'
                  }
                })

                if (route) {
                  updateRoute(route)
                }
              }
            })
          }}
        </MarkAsViewedMutation>
        {!isOpen && (
          <SliderButton
            className={getSliderButtonCss(zIndex - 1)}
            onClick={() => this.toggle(true)}
          />
        )}
      </div>
    )
  }

  private toggle = (open: boolean) => {
    this.setState({ isOpen: open })
  }
}
